import HttpUtils from "../../../utils/http.utils";

export default class ReCaptchaAPI {
  public static getReCaptchaSecret(): Promise<string> {
    return HttpUtils.get("/re-captcha/secret");
  }
}
